module.exports = __webpack_public_path__ + "static/media/SFST_1-475w.218e5ed0.webp";